import React from 'react';
import PropTypes from 'prop-types';
import loadingIcon from '../Spinner/loadingIcon.gif';
class Spinner extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    render() {
        const { imageSrc, imageStyle, overlayBackground, loading, label } = this.props;
        const overlayBlockStyle = {
            zIndex: "99999",
            height: "100vh",
            width: "100%",
            textAlign: "center",
            position: "absolute",
            display: loading ? "block" : "none",
            backgroundColor: overlayBackground
        }
        const spinnerLabelStyle = {
            clip: "rect(0 0 0 0)",
            clipPath: "inset(50%)",
            height: "1px",
            overflow: "hidden",
            position: "absolute",
            whiteSpace: "nowrap",
            width: "1px"
        }
        return (
            <div style={overlayBlockStyle}>
                <img style={imageStyle} src={imageSrc} alt='' />
                {label && <div role="alert" style={spinnerLabelStyle}>{label}</div>}
            </div>
        );
    }
}
Spinner.propTypes = {
    imageSrc: PropTypes.string,
    overlayBackground: PropTypes.string,
    imageStyle: PropTypes.object,
    loading: PropTypes.bool.isRequired,
    label: PropTypes.string,
};
Spinner.defaultProps = {
    imageSrc: loadingIcon,
    imageStyle: { marginTop: "20%" },
    overlayBackground: "rgba(0,0,0,0.4)"
};
export default Spinner;